// extracted by mini-css-extract-plugin
export default {"cta":"cOlEMS4f3Hm9S_n6W7sr","primary":"dx57PmExg2ZeO6eWIV7M"};